import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface CurrentOrganizationState {
    currentOrganizationId: string | null;
    setCurrentOrganizationId: (organizationId: string | null) => void;
    reset: () => void;
}

export const useCurrentOrganizationStore = create<CurrentOrganizationState>()(
    persist(
        (set) => ({
            currentOrganizationId: null,
            setCurrentOrganizationId: (organizationId) => set({ currentOrganizationId: organizationId }),
            reset: () => set({ currentOrganizationId: null })
        }),
        {
            name: 'current-organization',
            partialize: (state) => ({ currentOrganizationId: state.currentOrganizationId })
        }
    )
);

export const useCurrentOrganizationId = () => useCurrentOrganizationStore((state) => state.currentOrganizationId);
